import * as angular from 'angular';

export class LoginAsService {
    private $state;
    private auth;
    private localStorage;

    constructor($state, AuthFactory, LocalStorageService) {
        this.$state = $state;
        this.auth = AuthFactory;
        this.localStorage = LocalStorageService;
    }

    replaceToken(userId) {
        this.auth.getToken(userId).then(response => {
            this.localStorage.removeLocalData();
            this.localStorage.set(
                'common/token',
                'Bearer ' + response.data.token
            );
            this.$state.go('login');
        });
    }
}

angular
    .module('app')
    .service('LoginAsService', LoginAsService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/loginas.service.ts